import { EditableText } from "@/components/editable-text/editable-text"
import { handlebarsAutocomplete } from "@/components/editable-text/handlebars"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { ConditionsSection } from "./conditionssection"
import { languageName, localize, localized, useLanguage } from "./language"
import { MatchSection } from "./matchsection"
import { SetVarsSection } from "./setvarssection"

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  option: PlaybookOption
  vars: string[]
  onChange: (option: PlaybookOption) => void
}

export function OptionSettingsDialog({ open, onOpenChange, option, vars, onChange }: Props) {
  const language = useLanguage()

  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-xl">
      <DialogHeader>
        <DialogTitle>Option settings{language && ` · ${languageName(language)}`}</DialogTitle>
      </DialogHeader>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-medium">Id</h3>
          <p className="text-xs text-muted-foreground">What the channel sends back when tapped, and what a report counts on. Empty derives it from the label</p>
          <Input value={option.id ?? ""} onChange={e => onChange({ ...option, id: e.target.value || undefined })} placeholder="Derived from the label" />
        </div>
        <ConditionsSection conditions={option.conditions ?? []} vars={vars} onChange={conditions => onChange({ ...option, conditions })} />
        <SetVarsSection set={option.set ?? {}} onChange={set => onChange({ ...option, set })} />
        <SetVarsSection set={option.inc ?? {}} onChange={inc => onChange({ ...option, inc: Object.keys(inc).length ? inc : undefined })} counter />
        <MatchSection key={language} match={localized(option, "match", language) ?? []} onChange={match => onChange(localize(option, "match", match, language))} />
        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-medium">Say when picked</h3>
          <p className="text-xs text-muted-foreground">Shown right away, before the destination's own message.</p>
          <EditableText
            value={localized(option, "say", language) ?? ""}
            onChange={say => onChange(localize(option, "say", say || undefined, language))}
            extensions={[handlebarsAutocomplete(vars)]}
            placeholder={(language && option.say) || "Nothing extra"}
          />
        </div>
      </div>
    </DialogContent>
  </Dialog>
}
